import { render, staticRenderFns } from "./NewComplementPayments.vue?vue&type=template&id=6fb99edd&scoped=true&"
import script from "./NewComplementPayments.vue?vue&type=script&lang=js&"
export * from "./NewComplementPayments.vue?vue&type=script&lang=js&"
import style0 from "./NewComplementPayments.vue?vue&type=style&index=0&id=6fb99edd&scoped=true&lang=css&"
import style1 from "./NewComplementPayments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb99edd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb99edd')) {
      api.createRecord('6fb99edd', component.options)
    } else {
      api.reload('6fb99edd', component.options)
    }
    module.hot.accept("./NewComplementPayments.vue?vue&type=template&id=6fb99edd&scoped=true&", function () {
      api.rerender('6fb99edd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/NewDocumentRelated/NewComplementPayments.vue"
export default component.exports